import { Option, pipe } from 'effect';

import { INTERNAL_CUSTOMERS, ROLES, USER_REDIRECT_MAP } from '../AppConstants';
import { ROLE_NAME, User } from '../types/User';

export const isInternalCustomer = (user: User): boolean => INTERNAL_CUSTOMERS.includes(user.customerName);

export const getUserRoles = (user: User): Array<ROLE_NAME> => {
    let roles = [];
    const localStoreRoles = localStorage.getItem('userRoles');
    if (localStoreRoles) {
        roles = JSON.parse(localStoreRoles);
    }
    if (user?.roles) {
        roles = user.roles;
    }
    return roles;
};

export const userHasRoleAccess = (
    currentUser: User | undefined,
    allowedRoles: readonly ROLE_NAME[] | undefined
): boolean =>
    pipe(
        Option.zipWith(Option.fromNullable(currentUser), Option.fromNullable(allowedRoles), (user, roles) => ({
            user,
            roles
        })),
        Option.map(
            ({ user, roles }) => user.isAdmin || roles.length === 0 || containCommonElements(getUserRoles(user), roles)
        ),
        Option.getOrElse(() => false)
    );

const containCommonElements = (arr1: readonly string[], arr2: readonly string[]): boolean => {
    return arr1.some((item) => arr2.includes(item));
};

export const getRedirectPathByUser = (user: User): string => {
    if (user.isAdmin) return '/scanning';

    return pipe(
        Array.from(USER_REDIRECT_MAP.entries()),
        (redirections) => redirections.find(([role]) => user.roles.includes(role)),
        Option.fromNullable,
        Option.map(([_, path]) => path),
        Option.getOrElse(() => '/no-access')
    );
};

export const canUserMarkDamaged = (currentUser: User) => {
    if (!currentUser) return false;

    return userHasRoleAccess(currentUser, [ROLES.RECALLER, ROLES.DAMAGE_RECALLER]);
};
